// import logo from './logo.svg';
// import './App.css';
// <img src={logo} className="App-logo" alt="logo" />
import customs from './custom.css';

function App() {
  return (
    <div className="App">
            <section class="car_wrap">
          <header class="carwrapper-header">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h1><i class="fas fa-car"></i> Car Wrapper Designer</h1>
              </div>
              <div class="d-flex align-items-center gap-2">
                <button
                  class="btn btn-primary addmoretoucaring"
                  data-bs-toggle="modal"
                  data-bs-target="#carModal"
                >
                  <i class="bi bi-plus-lg"></i> Add More Car
                </button>
                <button class="btn-preview" id="previewBtn">
                  <i class="fas fa-eye"></i> Preview Design
                </button>
              </div>
            </div>
          </header>
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 order-2 order-md-1">
                <div class="controls p-2 pb-0">
                  <div class="tabs nav" id="myTab" role="tablist">
                    <div
                      class="tab active"
                      id="background"
                      data-bs-toggle="tab"
                      data-bs-target="#background-pane"
                    >
                      <span class="step-num">1</span>
                      <i class="fas fa-paint-roller"></i>
                      <div>Background</div>
                    </div>
                    <div
                      class="tab"
                      id="images"
                      data-bs-toggle="tab"
                      data-bs-target="#images-pane"
                    >
                      <span class="step-num">2</span>
                      <i class="fas fa-camera"></i>
                      <div>Images</div>
                    </div>
                    <div
                      class="tab"
                      id="text"
                      data-bs-toggle="tab"
                      data-bs-target="#text-pane"
                    >
                      <span class="step-num">3</span>
                      <i class="fas fa-font"></i>
                      <div>Text</div>
                    </div>
                    <div
                      class="tab"
                      id="finish"
                      data-bs-toggle="tab"
                      data-bs-target="#finish-pane"
                    >
                      <span class="step-num">4</span>
                      <i class="fas fa-check-circle"></i>
                      <div>Finish</div>
                    </div>
                  </div>
                  <div class="tab-content mt-3" id="myTabContent">
                    <div
                      class="tab-pane fade show active"
                      id="background-pane"
                      aria-labelledby="background"
                      tabindex="0"
                    >
                      <div class="panel">
                        <h3><i class="fas fa-palette"></i> Background Options</h3>

                        <div class="color-control">
                          <div class="color-label">
                            <i class="fas fa-fill"></i>
                            Solid Background Color
                          </div>
                          <div
                            class="color-preview"
                            id="solid-color-preview"
                            style={customs.bigblue}
                          ></div>
                        </div>

                        <div class="color-picker-container" id="solid-color-picker">
                          <div id="solid-picker"></div>
                        </div>

                        <div class="color-control">
                          <div class="color-label">
                            <i class="fa-solid fa-biohazard"></i>
                            Gradient Background Fade
                          </div>
                          <div
                            class="color-preview"
                            id="gradient-preview"
                            style={customs.bigblue}
                          ></div>
                        </div>

                        <div
                          class="color-picker-container"
                          id="gradient-color-picker"
                        >
                          <div class="gradient-controls">
                            <div class="gradient-color">
                              <label>Start Color</label>
                              <div
                                id="gradient-start-preview"
                                class="gradient-preview"
                                style={customs.b1}
                              ></div>
                            </div>
                            <div class="gradient-color">
                              <label>End Color</label>
                              <div
                                id="gradient-end-preview"
                                class="gradient-preview"
                                style={customs.b2}
                              ></div>
                            </div>
                          </div>

                          <div class="gradient-controls" style={customs.b3}>
                            <div class="gradient-color">
                              <div id="gradient-start-picker"></div>
                            </div>
                            <div class="gradient-color">
                              <div id="gradient-end-picker"></div>
                            </div>
                          </div>
                        </div>

                        <div class="color-control background-theme-control">
                          <div class="color-label">
                            <i class="fas fa-image"></i>
                            Background Theme
                          </div>
                          <div
                            class="color-preview position-relative"
                            id="theme-preview"
                          >
                            <img
                              width="100%"
                              height="100%"
                              src={"asset/img/icon/theme.png"}
                            />
                          </div>
                        </div>
                        <div class="backgroundthemeSowToogle">
                          <div
                            class="theme-images-container"
                            id="themeImagesContainer"
                          >
                            <button
                              class="bgthemeback commonbacktoolsdesign btn btn-primary"
                            >
                              <i class="bi bi-arrow-right"></i>
                            </button>
                            <div class="theme-images">
                              <div class="theme-image" data-theme="1">
                                <img
                                  src={"https://images.unsplash.com/photo-1501785888041-af3ef285b470?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Nature"
                                />
                              </div>
                              <div class="theme-image" data-theme="2">
                                <img
                                  src={"https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Mountains"
                                />
                              </div>
                              <div class="theme-image" data-theme="3">
                                <img
                                  src={"https://images.unsplash.com/photo-1511499767150-a48a237f0083?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Forest"
                                />
                              </div>
                              <div class="theme-image" data-theme="4">
                                <img
                                  src={"https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Beach"
                                />
                              </div>
                              <div class="theme-image" data-theme="5">
                                <img
                                  src={"https://images.unsplash.com/photo-1505142468610-359e7d316be0?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Lake"
                                />
                              </div>
                              <div class="theme-image" data-theme="6">
                                <img
                                  src={"https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Fog"
                                />
                              </div>
                              <div class="theme-image" data-theme="7">
                                <img
                                  src={"https://images.unsplash.com/photo-1426604966848-d7adac402bff?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Sunset"
                                />
                              </div>
                              <div class="theme-image" data-theme="8">
                                <img
                                  src={"https://images.unsplash.com/photo-1506260408121-e353d10b87c7?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Autumn"
                                />
                              </div>
                              <div class="theme-image" data-theme="9">
                                <img
                                  src={"https://images.unsplash.com/photo-1433086966358-54859d0ed716?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80"}
                                  alt="Waterfall"
                                />
                              </div>
                            </div>
                          </div>

                          <div class="theme-edit-container" id="themeEditContainer">
                            <div class="back-to-themes" id="backToThemes">
                              <i class="fas fa-arrow-left"></i>
                            </div>
                            <div class="edit-options">
                              <button class="edit-btn" id="colorEffectBtn">
                                <i class="fas fa-sliders-h"></i> Color & Effect
                              </button>
                              <button class="edit-btn" id="moveSizeBtn">
                                <i class="fas fa-arrows-alt"></i> Move & Size
                              </button>
                              <button class="edit-btn delete" id="deleteThemeBtn">
                                <i class="fas fa-trash"></i> Delete
                              </button>
                            </div>

                            <div class="effects-panel" id="effectsPanel">
                              <div class="effect-control">
                                <label for="themeOpacity"
                                  >Opacity: <span id="opacityValue">1</span></label
                                >
                                <input
                                  type="range"
                                  id="themeOpacity"
                                  min="0"
                                  max="1"
                                  step="0.1"
                                  value="1"
                                />
                              </div>

                              <div class="effect-control">
                                <label>Image Effects:</label>
                                <div class="effect-buttons">
                                  <button class="effect-btn" data-effect="normal">
                                    Normal
                                  </button>
                                  <button
                                    class="effect-btn"
                                    data-effect="grayscale"
                                  >
                                    Grayscale
                                  </button>
                                  <button class="effect-btn" data-effect="sepia">
                                    Sepia
                                  </button>
                                  <button class="effect-btn" data-effect="blur">
                                    Blur
                                  </button>
                                  <button class="effect-btn" data-effect="saturate">
                                    Saturate
                                  </button>
                                  <button class="effect-btn" data-effect="hue">
                                    Hue Rotate
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div class="move-size-panel" id="moveSizePanel">
                              <div class="move-size-control">
                                <h5><i class="fas fa-arrows-alt"></i> Move</h5>
                                <div class="controls">
                                  <div class="control-group">
                                    <div class="btn-group">
                                      <button class="control-btn" id="moveUp">
                                        <i class="fas fa-arrow-up"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button class="control-btn" id="moveLeft">
                                        <i class="fas fa-arrow-left"></i>
                                      </button>
                                      <button class="control-btn" id="moveRight">
                                        <i class="fas fa-arrow-right"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button class="control-btn" id="moveDown">
                                        <i class="fas fa-arrow-down"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-expand-alt"></i> Size</h5>
                                <div class="size-controls">
                                  <button class="size-btn" id="sizeDown">
                                    <i class="fas fa-minus"></i>
                                  </button>
                                  <span id="scaleValue">100%</span>
                                  <button class="size-btn" id="sizeUp">
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-sync-alt"></i> Rotate</h5>
                                <div class="controls">
                                  <div class="btn-group">
                                    <button class="control-btn" id="rotateLeft">
                                      <i class="fas fa-undo"></i>
                                    </button>
                                    <button class="control-btn" id="rotateRight">
                                      <i class="fas fa-redo"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-align-left"></i>Vertical</h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="alignTop">
                                    <i class="fas fa-arrow-up"></i> Top
                                  </button>
                                  <button class="align-btn" id="alignCenterV">
                                    Center
                                  </button>
                                  <button class="align-btn" id="alignBottom">
                                    <i class="fas fa-arrow-down"></i> Bottom
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5>
                                  <i class="fas fa-align-center"></i>
                                  Horizontal
                                </h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="alignLeft">
                                    <i class="fas fa-arrow-left"></i> Left
                                  </button>
                                  <button class="align-btn" id="alignCenterH">
                                    Center
                                  </button>
                                  <button class="align-btn" id="alignRight">
                                    <i class="fas fa-arrow-right"></i> Right
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                       
                        <div class="delete-control">
                          <div class="delete-label">
                            <i class="fa-solid fa-folder-minus"></i>
                            Delete Background Color
                          </div>
                          <div class="delete-icon">
                            <img
                              width="25px"
                              height="25px"
                              src={"asset/img/icon/delete.png"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="images-pane"
                      aria-labelledby="images"
                      tabindex="0"
                    >
                      <div class="panel image-panel">
                        <h3><i class="fa-solid fa-camera"></i> Images Options</h3>

                        
                        <div class="common-control upload-control">
                          <div class="common-label">
                            <i class="fa-solid fa-file-import"></i>
                            Upload Image
                          </div>
                          <div class="common-icon uploadcontrolicon">
                            <img
                              width="25px"
                              height="25px"
                              src={"asset/img/icon/upload.png"}
                            />
                          </div>
                        </div>
                        <div class="showuploadSlider">
                          
                          <div class="upload-options" id="uploadOptions">
                            <button
                              class="uploadBackTools commonbacktoolsdesign btn btn-primary"
                            >
                              <i class="bi bi-arrow-right"></i>
                            </button>
                            <input
                              type="file"
                              id="imageUpload"
                              accept="image/*"
                              style={customs.b4}
                            />
                            <div class="upload-btn" id="triggerUpload">
                              <i class="fa-solid fa-file-arrow-up"></i> Select Image
                            </div>
                            <p>or drag & drop an image here</p>
                            <img
                              id="uploadPreview"
                              class="upload-preview"
                              alt="Preview"
                            />
                          </div>

                          
                          <div
                            class="upload-edit-container"
                            id="uploadEditContainer"
                          >
                            <div class="back-to-themes" id="backTouploadimage">
                              <i class="fas fa-arrow-left"></i>
                            </div>
                            <div class="edit-options">
                              <button class="edit-btn" id="uploadColorEffectBtn">
                                <i class="fas fa-sliders-h"></i> Color & Effect
                              </button>
                              <button class="edit-btn" id="uploadMoveSizeBtn">
                                <i class="fas fa-arrows-alt"></i> Move & Size
                              </button>
                              <button class="edit-btn delete" id="uploadDeleteBtn">
                                <i class="fas fa-trash"></i> Delete
                              </button>
                            </div>

                           
                            <div class="effects-panel" id="uploadEffectsPanel">
                              <div class="effect-control">
                                <label for="uploadThemeOpacity"
                                  >Opacity:
                                  <span id="uploadOpacityValue">1</span></label
                                >
                                <input
                                  type="range"
                                  id="uploadThemeOpacity"
                                  min="0"
                                  max="1"
                                  step="0.1"
                                  value="1"
                                />
                              </div>

                              <div class="effect-control">
                                <label>Image Effects:</label>
                                <div class="effect-buttons">
                                  <button class="effect-btn" data-effect="normal">
                                    Normal
                                  </button>
                                  <button
                                    class="effect-btn"
                                    data-effect="grayscale"
                                  >
                                    Grayscale
                                  </button>
                                  <button class="effect-btn" data-effect="sepia">
                                    Sepia
                                  </button>
                                  <button class="effect-btn" data-effect="blur">
                                    Blur
                                  </button>
                                  <button class="effect-btn" data-effect="saturate">
                                    Saturate
                                  </button>
                                  <button class="effect-btn" data-effect="hue">
                                    Hue Rotate
                                  </button>
                                </div>
                              </div>
                            </div>

                            
                            <div class="move-size-panel" id="uploadMoveSizePanel">
                              <div class="move-size-control">
                                <h5><i class="fas fa-arrows-alt"></i> Move</h5>
                                <div class="controls">
                                  <div class="control-group">
                                    <div class="btn-group">
                                      <button class="control-btn" id="uploadMoveUp">
                                        <i class="fas fa-arrow-up"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button
                                        class="control-btn"
                                        id="uploadMoveLeft"
                                      >
                                        <i class="fas fa-arrow-left"></i>
                                      </button>
                                      <button
                                        class="control-btn"
                                        id="uploadMoveRight"
                                      >
                                        <i class="fas fa-arrow-right"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button
                                        class="control-btn"
                                        id="uploadMoveDown"
                                      >
                                        <i class="fas fa-arrow-down"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-expand-alt"></i> Size</h5>
                                <div class="size-controls">
                                  <button class="size-btn" id="uploadSizeDown">
                                    <i class="fas fa-minus"></i>
                                  </button>
                                  <span id="uploadScaleValue">100%</span>
                                  <button class="size-btn" id="uploadSizeUp">
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-sync-alt"></i> Rotate</h5>
                                <div class="controls">
                                  <div class="btn-group">
                                    <button
                                      class="control-btn"
                                      id="uploadRotateLeft"
                                    >
                                      <i class="fas fa-undo"></i>
                                    </button>
                                    <button
                                      class="control-btn"
                                      id="uploadRotateRight"
                                    >
                                      <i class="fas fa-redo"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-align-left"></i>Vertical</h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="uploadAlignTop">
                                    <i class="fas fa-arrow-up"></i> Top
                                  </button>
                                  <button class="align-btn" id="uploadAlignCenterV">
                                    Center
                                  </button>
                                  <button class="align-btn" id="uploadAlignBottom">
                                    <i class="fas fa-arrow-down"></i> Bottom
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5>
                                  <i class="fas fa-align-center"></i>
                                  Horizontal
                                </h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="uploadAlignLeft">
                                    <i class="fas fa-arrow-left"></i> Left
                                  </button>
                                  <button class="align-btn" id="uploadAlignCenterH">
                                    Center
                                  </button>
                                  <button class="align-btn" id="uploadAlignRight">
                                    <i class="fas fa-arrow-right"></i> Right
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="common-control background-sticker-control">
                          <div class="common-label sticker-label">
                            <i class="fa-brands fa-staylinked"></i>
                            Background Sticker
                          </div>
                          <div class="common-icon sticker-icon">
                            <img
                              width="25px"
                              height="25px"
                              src={"asset/img/icon/sticker.png"}
                            />
                          </div>
                        </div>
                        <div class="backgroundcommoslider">
                          <div
                            class="sticker-images-container"
                            id="stickerImagesContainer"
                          >
                            <button
                              class="btn btn-primary imagestickerBacktoos commonbacktoolsdesign"
                            >
                              <i class="fas fa-arrow-right"></i>
                            </button>

                            <div class="sticker-images">
                              <div class="sticker-image" data-sticker="1">
                                <img
                                  src={"https://cdn-icons-png.flaticon.com/512/4392/4392522.png"}
                                  alt="Star Sticker"
                                />
                              </div>
                              <div class="sticker-image" data-sticker="2">
                                <img
                                  src={"https://cdn-icons-png.flaticon.com/512/522/522510.png"}
                                  alt="Heart Sticker"
                                />
                              </div>
                              <div class="sticker-image" data-sticker="3">
                                <img
                                  src={"https://cdn-icons-png.flaticon.com/512/522/522511.png"}
                                  alt="Music Sticker"
                                />
                              </div>
                              <div class="sticker-image" data-sticker="4">
                                <img
                                  src="https://cdn-icons-png.flaticon.com/512/4392/4392450.png"
                                  alt="Car Sticker"
                                />
                              </div>
                              <div class="sticker-image" data-sticker="5">
                                <img
                                  src={"https://cdn-icons-png.flaticon.com/512/4392/4392528.png"}
                                  alt="Flag Sticker"
                                />
                              </div>
                              <div class="sticker-image" data-sticker="6">
                                <img
                                  src={"https://cdn-icons-png.flaticon.com/512/4392/4392455.png"}
                                  alt="Crown Sticker"
                                />
                              </div>
                            </div>
                          </div>

                          <div
                            class="sticker-edit-container"
                            id="stickerEditContainer"
                          >
                            <div class="back-to-stickers" id="backToStickers">
                              <i class="fas fa-arrow-left"></i>
                            </div>
                            <div class="edit-options">
                              <button class="edit-btn" id="stickerColorEffectBtn">
                                <i class="fas fa-sliders-h"></i> Color & Effect
                              </button>
                              <button class="edit-btn" id="stickerMoveSizeBtn">
                                <i class="fas fa-arrows-alt"></i> Move & Size
                              </button>
                              <button class="edit-btn delete" id="stickerDeleteBtn">
                                <i class="fas fa-trash"></i> Delete
                              </button>
                            </div>

                            <div class="effects-panel" id="stickerEffectsPanel">
                              <div class="effect-control">
                                <label for="stickerOpacity"
                                  >Opacity:
                                  <span id="stickerOpacityValue">1</span></label
                                >
                                <input
                                  type="range"
                                  id="stickerOpacity"
                                  min="0"
                                  max="1"
                                  step="0.1"
                                  value="1"
                                />
                              </div>

                              <div class="effect-control">
                                <label>Image Effects:</label>
                                <div class="effect-buttons">
                                  <button class="effect-btn" data-effect="normal">
                                    Normal
                                  </button>
                                  <button
                                    class="effect-btn"
                                    data-effect="grayscale"
                                  >
                                    Grayscale
                                  </button>
                                  <button class="effect-btn" data-effect="sepia">
                                    Sepia
                                  </button>
                                  <button class="effect-btn" data-effect="blur">
                                    Blur
                                  </button>
                                  <button class="effect-btn" data-effect="saturate">
                                    Saturate
                                  </button>
                                  <button class="effect-btn" data-effect="hue">
                                    Hue Rotate
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div class="move-size-panel" id="stickerMoveSizePanel">
                              <div class="move-size-control">
                                <h5><i class="fas fa-arrows-alt"></i> Move</h5>
                                <div class="controls">
                                  <div class="control-group">
                                    <div class="btn-group">
                                      <button
                                        class="control-btn"
                                        id="stickerMoveUp"
                                      >
                                        <i class="fas fa-arrow-up"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button
                                        class="control-btn"
                                        id="stickerMoveLeft"
                                      >
                                        <i class="fas fa-arrow-left"></i>
                                      </button>
                                      <button
                                        class="control-btn"
                                        id="stickerMoveRight"
                                      >
                                        <i class="fas fa-arrow-right"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button
                                        class="control-btn"
                                        id="stickerMoveDown"
                                      >
                                        <i class="fas fa-arrow-down"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-expand-alt"></i> Size</h5>
                                <div class="size-controls">
                                  <button class="size-btn" id="stickerSizeDown">
                                    <i class="fas fa-minus"></i>
                                  </button>
                                  <span id="stickerScaleValue">100%</span>
                                  <button class="size-btn" id="stickerSizeUp">
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-sync-alt"></i> Rotate</h5>
                                <div class="controls">
                                  <div class="btn-group">
                                    <button
                                      class="control-btn"
                                      id="stickerRotateLeft"
                                    >
                                      <i class="fas fa-undo"></i>
                                    </button>
                                    <button
                                      class="control-btn"
                                      id="stickerRotateRight"
                                    >
                                      <i class="fas fa-redo"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="move-size-control">
                                <h5><i class="fas fa-align-left"></i>Vertical</h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="stickerAlignTop">
                                    <i class="fas fa-arrow-up"></i> Top
                                  </button>
                                  <button
                                    class="align-btn"
                                    id="stickerAlignCenterV"
                                  >
                                    Center
                                  </button>
                                  <button class="align-btn" id="stickerAlignBottom">
                                    <i class="fas fa-arrow-down"></i> Bottom
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5>
                                  <i class="fas fa-align-center"></i>
                                  Horizontal
                                </h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="stickerAlignLeft">
                                    <i class="fas fa-arrow-left"></i> Left
                                  </button>
                                  <button
                                    class="align-btn"
                                    id="stickerAlignCenterH"
                                  >
                                    Center
                                  </button>
                                  <button class="align-btn" id="stickerAlignRight">
                                    <i class="fas fa-arrow-right"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="common-control background-url-control">
                          <div class="common-label url-label">
                            <i class="fa-solid fa-link"></i>
                            Background From Url
                          </div>
                          <div class="common-icon url-icon">
                            <img
                              width="25px"
                              height="25px"
                              src={"asset/img/icon/link.png"}
                            />
                          </div>
                        </div>
                        <div class="urlshowshingtoogle">
                          <div class="url-input-container" id="urlInputContainer">
                            <button
                              class="btn btn-primary backuriltools commonbacktoolsdesign"
                            >
                              <i class="fas fa-arrow-right"></i>
                            </button>

                            <div class="url-controls">
                              <div class="url-input-group">
                                <input
                                  type="text"
                                  id="imageUrlInput"
                                  placeholder="https://example.com/image.jpg"
                                />
                                <button id="loadImageUrlBtn">Load Image</button>
                              </div>
                              <div class="url-preview">
                                <img id="urlPreview" alt="URL Image Preview" />
                                <p id="urlPlaceholder">Preview will appear here</p>
                              </div>
                              <div class="url-confirm-buttons">
                                <button class="confirm" id="confirmUrlBtn">
                                  Add to Background
                                </button>
                                <button class="cancel" id="cancelUrlBtn">
                                  Cancel
                                </button>
                              </div>
                            </div>
                          </div>

                          
                          <div class="url-edit-container" id="urlEditContainer">
                            <div class="back-to-url" id="backToUrl">
                              <i class="fas fa-arrow-left"></i>
                            </div>
                            <div class="edit-options">
                              <button class="edit-btn" id="urlColorEffectBtn">
                                <i class="fas fa-sliders-h"></i> Color & Effect
                              </button>
                              <button class="edit-btn" id="urlMoveSizeBtn">
                                <i class="fas fa-arrows-alt"></i> Move & Size
                              </button>
                              <button class="edit-btn delete" id="urlDeleteBtn">
                                <i class="fas fa-trash"></i> Delete
                              </button>
                            </div>

                            <div class="effects-panel" id="urlEffectsPanel">
                              <div class="effect-control">
                                <label for="urlOpacity"
                                  >Opacity:
                                  <span id="urlOpacityValue">1</span></label
                                >
                                <input
                                  type="range"
                                  id="urlOpacity"
                                  min="0"
                                  max="1"
                                  step="0.1"
                                  value="1"
                                />
                              </div>

                              <div class="effect-control">
                                <label>Image Effects:</label>
                                <div class="effect-buttons">
                                  <button class="effect-btn" data-effect="normal">
                                    Normal
                                  </button>
                                  <button
                                    class="effect-btn"
                                    data-effect="grayscale"
                                  >
                                    Grayscale
                                  </button>
                                  <button class="effect-btn" data-effect="sepia">
                                    Sepia
                                  </button>
                                  <button class="effect-btn" data-effect="blur">
                                    Blur
                                  </button>
                                  <button class="effect-btn" data-effect="saturate">
                                    Saturate
                                  </button>
                                  <button class="effect-btn" data-effect="hue">
                                    Hue Rotate
                                  </button>
                                </div>
                              </div>
                            </div>

                            <div class="move-size-panel" id="urlMoveSizePanel">
                              <div class="move-size-control">
                                <h5><i class="fas fa-arrows-alt"></i> Move</h5>
                                <div class="controls">
                                  <div class="control-group">
                                    <div class="btn-group">
                                      <button class="control-btn" id="urlMoveUp">
                                        <i class="fas fa-arrow-up"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button class="control-btn" id="urlMoveLeft">
                                        <i class="fas fa-arrow-left"></i>
                                      </button>
                                      <button class="control-btn" id="urlMoveRight">
                                        <i class="fas fa-arrow-right"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button class="control-btn" id="urlMoveDown">
                                        <i class="fas fa-arrow-down"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-expand-alt"></i> Size</h5>
                                <div class="size-controls">
                                  <button class="size-btn" id="urlSizeDown">
                                    <i class="fas fa-minus"></i>
                                  </button>
                                  <span id="urlScaleValue">100%</span>
                                  <button class="size-btn" id="urlSizeUp">
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-sync-alt"></i> Rotate</h5>
                                <div class="controls">
                                  <div class="btn-group">
                                    <button class="control-btn" id="urlRotateLeft">
                                      <i class="fas fa-undo"></i>
                                    </button>
                                    <button class="control-btn" id="urlRotateRight">
                                      <i class="fas fa-redo"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="move-size-control">
                                <h5><i class="fas fa-align-left"></i>Vertical</h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="bgurlAlignTop">
                                    <i class="fas fa-arrow-up"></i> Top
                                  </button>
                                  <button class="align-btn" id="bgurlAlignCenterV">
                                    Center
                                  </button>
                                  <button class="align-btn" id="bgurlAlignBottom">
                                    <i class="fas fa-arrow-down"></i> Bottom
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5>
                                  <i class="fas fa-align-center"></i>
                                  Horizontal
                                </h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="bgurlAlignLeft">
                                    <i class="fas fa-arrow-left"></i> Left
                                  </button>
                                  <button class="align-btn" id="bgurlAlignCenterH">
                                    Center
                                  </button>
                                  <button class="align-btn" id="bgurlAlignRight">
                                    <i class="fas fa-arrow-right"></i> Right
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="common-control delete-control-img">
                          <div class="common-label delete-label-img">
                            <i class="fa-solid fa-folder-minus"></i>
                            Delete All Image
                          </div>
                          <div class="common-icon delete-icon-img">
                            <img
                              width="25px"
                              height="25px"
                              src={"asset/img/icon/delete.png"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="text-pane"
                      role="tabpanel"
                      aria-labelledby="text"
                      tabindex="0"
                    >
                      <div class="panel text-panel">
                        <h3><i class="fa-solid fa-font"></i> Text Options</h3>

                        
                        <div class="common-control text-control">
                          <div class="common-label text-label">
                            <i class="fa-solid fa-text-height"></i>
                            Add Text
                          </div>
                          <div class="common-icon text-icon">
                            <img
                              width="25px"
                              height="25px"
                              src={"asset/img/icon/text.png"}
                            />
                          </div>
                        </div>
                        <div class="textpanaleshowtoogle">
                         
                          <div class="text-input-container" id="textInputContainer">
                            <button
                              class="btn btn-primary gonexttextChange commonbacktoolsdesign"
                            >
                              <i class="bi bi-arrow-right"></i>
                            </button>
                            <div class="text-input-group">
                              <input
                                type="text"
                                id="textInput"
                                placeholder="Enter your text here"
                              />
                              <button id="addTextBtn">Add Text</button>
                            </div>
                          </div>

                          
                          <div class="text-edit-container" id="textEditContainer">
                            <button
                              class="btn btn-primary gobacktextChange commonbacktoolsdesign"
                            >
                              <i class="bi bi-arrow-left"></i>
                            </button>
                            <div class="chnagess-text mb-1">
                              <button id="changeTextBtn" class="edit-btn w-100">
                                Change Text
                              </button>
                              <input
                                type="text"
                                id="textChangerInput"
                                style={customs.b5}
                              />
                            </div>
                            <div class="edit-options">
                              <button class="edit-btn" id="textColorEffectBtn">
                                <i class="fas fa-sliders-h"></i> Color & Effect
                              </button>
                              <button class="edit-btn" id="textMoveSizeBtn">
                                <i class="fas fa-arrows-alt"></i> Move & Size
                              </button>
                              <button class="edit-btn" id="textFontBtn">
                                <i class="fas fa-font"></i> Font Family
                              </button>
                              <button class="edit-btn delete" id="textDeleteBtn">
                                <i class="fas fa-trash"></i> Delete Selected
                              </button>
                              <button
                                class="edit-btn delete"
                                id="textDeleteBtnAllselected"
                              >
                                <i class="fas fa-trash"></i> Clear All
                              </button>
                            </div>

                            
                            <div class="effects-panel" id="textEffectsPanel">
                              <div class="d-flex justify-content-between">
                                <div class="effect-control">
                                  <label for="textColor">Text Color:</label>
                                  <input
                                    type="color"
                                    id="textColor"
                                    value="#000000"
                                  />
                                </div>

                                <div class="effect-control text-center">
                                  <label for="textBgColor">Background Color:</label>
                                  <div class="text-bg-options">
                                    <input
                                      type="color"
                                      id="textBgColor"
                                      value="#ffffff"
                                    />
                                    <button id="transparentBgBtn">
                                      Transparent
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="effect-control">
                                <label for="textSize"
                                  >Font Size:
                                  <span id="textSizeValue">24px</span></label
                                >
                                <input
                                  type="range"
                                  id="textSize"
                                  min="12"
                                  max="72"
                                  value="24"
                                />
                              </div>

                              <div class="effect-control">
                                <label>Text Style:</label>
                                <div class="text-style-controls">
                                  <button class="style-btn" id="textBoldBtn">
                                    <i class="fas fa-bold"></i> Bold
                                  </button>
                                  <button class="style-btn" id="textItalicBtn">
                                    <i class="fas fa-italic"></i> Italic
                                  </button>
                                  <button class="style-btn" id="textUnderlineBtn">
                                    <i class="fas fa-underline"></i> Underline
                                  </button>
                                  <button class="style-btn" id="textOutlineBtn">
                                    <i class="fas fa-text-size"></i> Outline
                                  </button>
                                  <button class="style-btn" id="textGradientBtn">
                                    <i class="fas fa-paint-roller"></i> Gradient
                                  </button>
                                </div>
                              </div>

                              <div class="effect-control">
                                <label>Text Effects:</label>
                                <div class="text-style-controls">
                                  <button class="style-btn" id="textShadowBtn">
                                    <i class="fas fa-moon"></i> Shadow
                                  </button>
                                  <button class="style-btn" id="text3dBtn">
                                    <i class="fas fa-cube"></i> 3D Effect
                                  </button>
                                  <button class="style-btn" id="textNeonBtn">
                                    <i class="fas fa-lightbulb"></i> Neon
                                  </button>
                                </div>
                              </div>
                            </div>

                           
                            <div class="move-size-panel" id="textMoveSizePanel">
                              <div class="move-size-control">
                                <h5><i class="fas fa-arrows-alt"></i> Move</h5>
                                <div class="controls">
                                  <div class="control-group">
                                    <div class="btn-group">
                                      <button class="control-btn" id="textMoveUp">
                                        <i class="fas fa-arrow-up"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button class="control-btn" id="textMoveLeft">
                                        <i class="fas fa-arrow-left"></i>
                                      </button>
                                      <button
                                        class="control-btn"
                                        id="textMoveRight"
                                      >
                                        <i class="fas fa-arrow-right"></i>
                                      </button>
                                    </div>
                                    <div class="btn-group">
                                      <button class="control-btn" id="textMoveDown">
                                        <i class="fas fa-arrow-down"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-expand-alt"></i> Size</h5>
                                <div class="size-controls">
                                  <button class="size-btn" id="textSizeDown">
                                    <i class="fas fa-minus"></i>
                                  </button>
                                  <span id="textScaleValue">100%</span>
                                  <button class="size-btn" id="textSizeUp">
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5><i class="fas fa-sync-alt"></i> Rotate</h5>
                                <div class="controls">
                                  <div class="btn-group">
                                    <button class="control-btn" id="textRotateLeft">
                                      <i class="fas fa-undo"></i>
                                    </button>
                                    <button
                                      class="control-btn"
                                      id="textRotateRight"
                                    >
                                      <i class="fas fa-redo"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div class="move-size-control">
                                <h5>
                                  <i class="fas fa-align-left"></i> Text Alignment
                                </h5>
                                <div class="align-controls">
                                  <button class="align-btn" id="textAlignLeft">
                                    <i class="fas fa-align-left"></i>
                                  </button>
                                  <button class="align-btn" id="textAlignCenter">
                                    <i class="fas fa-align-center"></i>
                                  </button>
                                  <button class="align-btn" id="textAlignRight">
                                    <i class="fas fa-align-right"></i>
                                  </button>
                                </div>
                              </div>
                            </div>

                            
                            <div class="font-family-panel" id="fontFamilyPanel">
                              <div class="font-grid">
                                <button
                                  class="font-btn"
                                  data-font="Arial, sans-serif"
                                >
                                  Arial
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Times New Roman', serif"
                                >
                                  Times New Roman
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Courier New', monospace"
                                >
                                  Courier New
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Pacifico', cursive"
                                >
                                  Pacifico
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Lobster', cursive"
                                >
                                  Lobster
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Dancing Script', cursive"
                                >
                                  Dancing Script
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Indie Flower', cursive"
                                >
                                  Indie Flower
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Shadows Into Light', cursive"
                                >
                                  Shadows Into Light
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Great Vibes', cursive"
                                >
                                  Great Vibes
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Kaushan Script', cursive"
                                >
                                  Kaushan Script
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Playball', cursive"
                                >
                                  Playball
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Satisfy', cursive"
                                >
                                  Satisfy
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Berkshire Swash', cursive"
                                >
                                  Berkshire Swash
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Roboto', sans-serif"
                                >
                                  Roboto
                                </button>
                                <button
                                  class="font-btn"
                                  data-font="'Montserrat', sans-serif"
                                >
                                  Montserrat
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div class="common-control texteffecth-control">
                          <div class="common-label texteffecth-label">
                            <i class="fas fa-draw-polygon"></i>
                            Add Text Effect Logo
                          </div>
                          <div class="common-icon texteffecth-icon">
                            <img
                              width="25px"
                              height="25px"
                              src={"asset/img/icon/le.png"}
                            />
                          </div>
                        </div>
                        <div class="showoftexteffectlog">
                          <div class="textfirstpartdemo">
                            <button
                              class="textEffectOf-back-panel btn btn-primary commonbacktoolsdesign btn"
                              onclick="textEffectOfbackpanel()"
                            >
                              <i class="bi bi-arrow-right"></i>
                            </button>
                            <div
                              class="textEffectOf-controls textEffectOf-controls-ganarate"
                            >
                              <input
                                id="textEffectOf-txttoEffect"
                                placeholder="Type your text here..."
                                value="CAR"
                              />
                              <button
                                class="buttonofGanarate"
                                onclick="textEffectOf_generateEffects()"
                              >
                                Generate Effects
                              </button>
                            </div>

                            <div
                              id="textEffectOf-texttoeffects"
                              class="textEffectOf-effects"
                            ></div>
                          </div>

                          <div
                            class="textEffectOf-back-to-effects"
                            id="textEffectOf-backToEffects"
                          >
                            <button
                              class="textEffectOf-back-btn btn commonbacktoolsdesign"
                              onclick="textEffectOf_backToEffects()"
                            >
                              <i class="bi bi-arrow-left"></i>
                            </button>
                          </div>

                          <div class="textEffectOf-edit-panel">
                            <div class="textEffectOf-edit-options">
                              <button
                                class="textEffectOf-edit-btn"
                                id="textEffectOf-moveSizeBtn"
                              >
                                <i class="fas fa-arrows-alt"></i> Move & Size
                              </button>
                              <button
                                class="textEffectOf-edit-btn"
                                id="textEffectOf-fontEffectBtn"
                              >
                                <i class="fas fa-font"></i> Font Effect
                              </button>
                              <button
                                class="textEffectOf-edit-btn textEffectOf-delete"
                                id="textEffectOf-deleteBtn"
                              >
                                <i class="fas fa-trash"></i> Delete Selected
                              </button>
                              <button
                                class="textEffectOf-edit-btn"
                                id="textEffectOf-clearAllBtn"
                              >
                                <i class="fas fa-broom"></i> Clear All
                              </button>
                            </div>

                            <div
                              class="textEffectOf-move-size-panel"
                              id="textEffectOf-moveSizePanel"
                            >
                              <div class="textEffectOf-move-size-control">
                                <h5><i class="fas fa-arrows-alt"></i> Move</h5>
                                <div class="textEffectOf-controls">
                                  <div class="textEffectOf-control-group">
                                    <div class="textEffectOf-btn-group">
                                      <button
                                        class="textEffectOf-control-btn"
                                        id="textEffectOf-moveUp"
                                      >
                                        <i class="fas fa-arrow-up"></i>
                                      </button>
                                    </div>
                                    <div class="textEffectOf-btn-group">
                                      <button
                                        class="textEffectOf-control-btn"
                                        id="textEffectOf-moveLeft"
                                      >
                                        <i class="fas fa-arrow-left"></i>
                                      </button>
                                      <button
                                        class="textEffectOf-control-btn"
                                        id="textEffectOf-moveRight"
                                      >
                                        <i class="fas fa-arrow-right"></i>
                                      </button>
                                    </div>
                                    <div class="textEffectOf-btn-group">
                                      <button
                                        class="textEffectOf-control-btn"
                                        id="textEffectOf-moveDown"
                                      >
                                        <i class="fas fa-arrow-down"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div class="textEffectOf-move-size-control">
                                <h5><i class="fas fa-expand-alt"></i> Size</h5>
                                <div class="textEffectOf-size-controls">
                                  <button
                                    class="textEffectOf-size-btn"
                                    id="textEffectOf-sizeDown"
                                  >
                                    <i class="fas fa-minus"></i>
                                  </button>
                                  <span
                                    class="textEffectOf-scale-value"
                                    id="textEffectOf-scaleValue"
                                    >100%</span
                                  >
                                  <button
                                    class="textEffectOf-size-btn"
                                    id="textEffectOf-sizeUp"
                                  >
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>

                              <div class="textEffectOf-move-size-control">
                                <h5><i class="fas fa-sync-alt"></i> Rotate</h5>
                                <div class="textEffectOf-controls">
                                  <div class="textEffectOf-btn-group">
                                    <button
                                      class="textEffectOf-control-btn"
                                      id="textEffectOf-rotateLeft"
                                    >
                                      <i class="fas fa-undo"></i>
                                    </button>
                                    <button
                                      class="textEffectOf-control-btn"
                                      id="textEffectOf-rotateRight"
                                    >
                                      <i class="fas fa-redo"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="textEffectOf-font-effect-panel"
                              id="textEffectOf-fontEffectPanel"
                            >
                              <div class="textEffectOf-font-control">
                                <h5>Text Style:</h5>
                                <div class="textEffectOf-text-style-controls">
                                  <button
                                    class="textEffectOf-style-btn"
                                    id="textEffectOf-boldBtn"
                                  >
                                    <i class="fas fa-bold"></i> Bold
                                  </button>
                                  <button
                                    class="textEffectOf-style-btn"
                                    id="textEffectOf-italicBtn"
                                  >
                                    <i class="fas fa-italic"></i> Italic
                                  </button>
                                  <button
                                    class="textEffectOf-style-btn"
                                    id="textEffectOf-underlineBtn"
                                  >
                                    <i class="fas fa-underline"></i> Underline
                                  </button>
                                  <button
                                    class="textEffectOf-style-btn"
                                    id="textEffectOf-outlineBtn"
                                  >
                                    <i class="fas fa-border-style"></i> Outline
                                  </button>
                                </div>
                              </div>

                              <div class="textEffectOf-font-control mt-3">
                                <div class="d-flex align-items-center">
                                  <h5>Opacity:</h5>
                                  <div class="textEffectOf-size-controls">
                                    <span
                                      style={customs.b4}
                                      class="textEffectOf-scale-value"
                                      id="textEffectOf-opacityValue"
                                    >
                                      1</span
                                    >
                                  </div>
                                </div>

                                <div class="textEffectOf-opacity-controls">
                                  <input
                                    type="range"
                                    min="0"
                                    max="1"
                                    step="0.1"
                                    value="1"
                                    class="textEffectOf-opacity-slider"
                                    id="textEffectOf-opacitySlider"
                                  />
                                </div>
                              </div>

                              <div class="textEffectOf-font-control d-none">
                                <h5>
                                  <i class="fas fa-text-height"></i> Font Size
                                </h5>
                                <div class="textEffectOf-font-size-controls">
                                  <button
                                    class="textEffectOf-font-btn"
                                    id="textEffectOf-fontSizeDown"
                                  >
                                    <i class="fas fa-minus"></i>
                                  </button>
                                  <span
                                    class="textEffectOf-font-size-value"
                                    id="textEffectOf-fontSizeValue"
                                    >48px</span
                                  >
                                  <button
                                    class="textEffectOf-font-btn"
                                    id="textEffectOf-fontSizeUp"
                                  >
                                    <i class="fas fa-plus"></i>
                                  </button>
                                </div>
                              </div>
                              <div
                                class="textEffectOf-text-edit-control"
                                style={customs.b6}
                              >
                                <h5
                                  style={customs.b7}
                                >
                                  Edit Text
                                </h5>
                                <input
                                  type="text"
                                  id="textEffectOf-textEditInput"
                                  placeholder="Edit selected text..."
                                />
                                <button onclick="textEffectOf_updateSelectedText()">
                                  Update Text
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="delete-control textall-delete-control">
                          <div class="delete-label textall-delete-control-lablel">
                            <i class="fa-solid fa-folder-minus"></i>
                            Delete All Text
                          </div>
                          <div class="delete-icon textall-delete-control-icon">
                            <img
                              width="25px"
                              height="25px"
                              src={"asset/img/icon/delete.png"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="tab-pane fade"
                      id="finish-pane"
                      role="tabpanel"
                      aria-labelledby="finish"
                      tabindex="0"
                    >
                      <div class="panel">
                        <div class="finished-wrapper bg-white p-4">
                          <h4 class="mb-4">
                            <i class="bi bi-save"></i> Save Your Design
                          </h4>

                          <div class="mb-3">
                            <label for="finished-email" class="form-label"
                              >Email</label
                            >
                            <input
                              type="email"
                              class="form-control"
                              id="finished-email"
                            />
                          </div>

                          <div class="mb-3">
                            <label for="finished-confirm-email" class="form-label"
                              >Confirm Email</label
                            >
                            <input
                              type="email"
                              class="form-control"
                              id="finished-confirm-email"
                            />
                          </div>

                          <div class="form-check d-flex align-items-start mb-3">
                            <div
                              id="finished-public"
                              class="finished-checkbox me-2"
                            ></div>
                            <label class="finished-label" for="finished-public"
                              >Yes, share my design in the public gallery</label
                            >
                          </div>

                          <div class="form-check d-flex align-items-start mb-4">
                            <div
                              id="finished-rights"
                              class="finished-checkbox me-2 border-danger"
                            ></div>
                            <label class="finished-label" for="finished-rights"
                              >I verify I have the rights to use any image(s) or
                              logo(s) I've uploaded, if any</label
                            >
                          </div>

                          <button class="finished-btn">
                            OK <span>&#10132;</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="backgroundadjustmentZindexBlock">
                  <h3><i class="bi bi-wrench-adjustable"></i> layer adjustment</h3>
                  <div class="backgroundadjustmentZindex">
                    <button class="allbgzindex" data-target="url-bg-image">
                      URL Background
                    </button>
                    <button class="allbgzindex" data-target="theme-bg-image">
                      Theme Background
                    </button>
                    <button class="allbgzindex" data-target="uploaded-bg-image">
                      Uploaded Background
                    </button>
                    <button class="allbgzindex" data-target="sticker-bg-image">
                      Sticker Background
                    </button>
                    <button class="allbgzindex" data-target="text-element">
                      Row Text
                    </button>
                    <button
                      class="allbgzindex"
                      data-target="textEffectOf-text-effect-container"
                    >
                      Text Logo Effect
                    </button>
                  </div>
                </div>
              </div>

              
              <div class="col-md-6 order-1 order-md-2">
                <div class="sticky-top">
                  <div class="preview">
                    <div class="car-wrapper">
                      <div class="car-container">
                        <div class="car-background" id="car-background"></div>
                        <div
                          class="textEffectOf-text-effect-container"
                          id="textEffectOf-textEffectContainer"
                        ></div>
                        <img
                          class="theme-bg-image"
                          id="theme-bg-image"
                          src={""}
                          alt="Theme Background"
                          style={customs.b4}
                        />
                        <img
                          class="uploaded-bg-image"
                          id="uploaded-bg-image"
                          src={""}
                          alt="Uploaded Background"
                          style={customs.b4}
                        />
                        <div class="car-image" id="addmorecarall">
                          <img src={"asset/img/car/foreground.png"} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

       
        <div class="preview-modal" id="previewModal">
          <div class="modal-content">
            <button class="close-modal" id="closeModal">&times;</button>
            <div class="modal-header">
              <h2><i class="fas fa-eye"></i> Design Preview</h2>
            </div>

            <div class="modal-car-container">
              <div class="modal-car-wrapper" id="modalCarWrapper">
                <div class="modal-car-background" id="modalCarBackground"></div>
              </div>
            </div>

            <div class="modal-controls">
              <button class="rotate-btn" id="rotateBtn">
                <i class="fas fa-sync"></i> Rotate Design
              </button>
            </div>
          </div>
        </div>

       
        <div class="image-confirm-modal" id="imageConfirmModal">
          <div class="confirm-modal-content">
            <div class="confirm-modal-header">
              <h3>Add This Image as Background?</h3>
              <p>Preview the selected image before applying</p>
            </div>

            <div class="image-preview" id="imagePreview">
              <img src={""} alt="Selected Image Preview" id="selectedImagePreview" />
            </div>

            <div class="confirm-buttons">
              <button class="confirm-btn confirm" id="confirmImageBtn">
                Add to Background
              </button>
              <button class="confirm-btn cancel" id="cancelImageBtn">Cancel</button>
            </div>
          </div>
        </div>

        <div
          class="image-confirm-modal sticker-confirm-modal"
          id="stickerConfirmModal"
        >
          <div class="confirm-modal-content">
            <div class="confirm-modal-header">
              <h3>Add This Image as Background?</h3>
              <p>Preview the selected image before applying</p>
            </div>

            <div class="sticker-preview" id="stickerPreview">
              <img
                src={""}
                alt="Selected Image Preview"
                id="selectedstickerPreview"
              />
            </div>

            <div class="confirm-buttons">
              <button class="confirm-btn confirm" id="confirmstickerBtn">
                Add to Background
              </button>
              <button class="confirm-btn cancel" id="cancelStickerBtn">
                Cancel
              </button>
            </div>
          </div>
        </div>

       
        <div
          class="modal fade"
          id="carModal"
          tabindex="-1"
          aria-labelledby="carModalLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-lg modal-dialog-centered modal-content-choosecar"
          >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="carModalLabel">Choose a Car</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>
              <div class="modal-body">
                <div class="row g-3">
                  
                  <div class="col-4">
                    <img
                      src={"asset/img/car/boat.png"}
                      class="img-fluid car-option"
                      onclick="selectCar(this.src)"
                    />
                  </div>
                  <div class="col-4">
                    <img
                      src={"asset/img/car/box.png"}
                      class="img-fluid car-option"
                      onclick="selectCar(this.src)"
                    />
                  </div>
                  <div class="col-4">
                    <img
                      src={"asset/img/car/semi box.png"}
                      class="img-fluid car-option"
                      onclick="selectCar(this.src)"
                    />
                  </div>
                  <div class="col-4">
                    <img
                      src={"asset/img/car/lam.png"}
                      class="img-fluid car-option"
                      onclick="selectCar(this.src)"
                    />
                  </div>
                  <div class="col-4">
                    <img
                      src={"asset/img/car/foreground.png"}
                      class="img-fluid car-option"
                      onclick="selectCar(this.src)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        
    </div>
  );
}

export default App;
